const privateResidenceAcc = (() => {
  const pagePrivateResidence = (document.getElementById("pagePrivateResidence") != null);
  if (pagePrivateResidence) {



    let secs = document.querySelectorAll('.js-sec-list');

    secs.forEach((element, index) => {
      let wrap = element.querySelector('.js-acc-wrap');
      let area = wrap.querySelector('.js-acc-area');
      let btnBox = wrap.querySelector('.js-btn-box');
      let open = btnBox.querySelector('.open');
      let close = btnBox.querySelector('.close');

      let areaH = area.clientHeight;
      // console.log(areaH)

      btnBox.addEventListener('click', () => {
        if (btnBox.classList.contains('is-act') == true) {
          btnBox.classList.remove('is-act');
          area.style.height = `${0}px`
        } else {
          btnBox.classList.add('is-act');
          area.style.height = `${areaH}px`
        }

      });

      setTimeout(() => {
        area.style.height = `${0}px`
      }, 500);

    });



  }
})()
export default privateResidenceAcc;